@if (isLoading()) {
  <elcia-loader/>
} @else {
  <p-table [scrollable]="true" [size]="'small'" [value]="users()" scrollHeight="flex" stripedRows>
    <ng-template #header>
      <tr>
        <th pResizableColumn>{{ 'customer.name' | translate }}</th>
        <th pResizableColumn>{{ 'user.email' | translate }}</th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template #body let-row>
      <tr>
        <td>{{ row.fullName }}</td>
        <td>{{ row.email }}</td>
        <td class="flex justify-end gap-2">
          <elcia-button (onClick)="delete(row)" [disabled]="row.id === currentUserId()" [icon]="'delete'"
                        [severity]="'danger'" [variant]="'text'"/>
        </td>
      </tr>
    </ng-template>
  </p-table>
}
